import React, { useEffect, useState } from 'react'
import Input from 'components/Input'
import PhoneNumberInput from 'components/PhoneNumberInput'
import { withTranslation } from 'react-i18next'
// import { useSelector } from 'react-redux'
import { filterValues } from 'Helper'
import useSWR from 'swr'
import { useFormContext } from 'react-hook-form'

const StepOneForm = ({ t }) => {
  const { data: Countries } = useSWR('collections/countries')
  const { data: Categories } = useSWR('collections/categories?page=1&page-size=500')

  const [countries, setCountries] = useState([])
  const [categories, setCategories] = useState(null)

  const [selectedCountry, setSelectedCountry] = useState('NG')

  const { watch, setValue } = useFormContext()

  useEffect(() => {
    if (Countries && Categories) {
      setCountries(Countries.data.filter(x => x.name === 'Ghana' || x.name === 'Nigeria'))
      setCategories(Categories.data)
    }
  }, [Countries, Categories]);

  const countryId = watch('country_id');
  useEffect(() => {
    setSelectedCountry(countries.find(x => x.id === countryId));
  }, [countryId, countries, watch]);

  const fields = [
    {
      name: 'name',
      label: t('registration.field.bname'),
      placeholder: t('registration.field.bname_placeholder')
    },
    {
      name: 'primary_email',
      label: t('registration.field.bmail'),
      placeholder: t('registration.field.bmail_placeholder')
    },
    {
      name: 'country_id',
      label: t('registration.field.country'),
      placeholder: t('registration.field.country_placeholder'),
      options: countries?.length ? filterValues({ options: countries, param: { value: 'id', label: 'name' } }) : []
    },
    {
      name: 'category_id',
      label: t('registration.field.category'),
      placeholder: t('registration.field.category_placeholder'),
      options: categories?.length ? filterValues({ options: categories, param: { value: 'id', label: 'name' } }) : []
    },
    {
      name: 'primary_phone',
      label: t('registration.field.phone'),
    }
  ]
  return (
    <div className='flex flex-col gap-4 text-left'>
      {
        fields.map(field => {
          return (
            <div key={field.name}>
              {
                field.name === 'primary_phone' ? (
                  <>
                    <PhoneNumberInput
                      name={field.name}
                      label={field.label}
                      country={selectedCountry?.iso2}
                      international
                      className={{ bodyClass: "bg-white border border-border-lines w-full rounded-lg pl-2", inputClass: 'py-3 rounded-r-lg !bg-white' }}
                      singleInputClassName={'bg-white w-full rounded-lg pl-2 py-3'}
                      disabled
                      errorState={(data) => setValue('phoneError', data)}
                      labelwithin
                      code={selectedCountry?.phone_code}
                    />
                    <span className='text-[blue]'>{!watch('country_id') && 'must select a country first'} </span>
                  </>) : (
                  <Input
                    name={field.name}
                    label={field.label}
                    options={field?.options}
                    placeholder={field?.placeholder}
                    classList='!bg-white !border-border-lines rounded-lg placeholder:text-placeholder text-left'
                  />
                )
              }
            </div>
          )
        })
      }
    </div>
  )
}

export default withTranslation()(StepOneForm)